var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 29.6,
    rx: 4.5,
    fill: "#006AB3",
    stroke: "#006AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15C25 15.2984 24.8815 15.5845 24.6705 15.7955C24.4595 16.0065 24.1734 16.125 23.875 16.125L8.125 16.125C7.82663 16.125 7.54048 16.0065 7.3295 15.7955C7.11853 15.5845 7 15.2984 7 15C7 14.7016 7.11853 14.4155 7.3295 14.2045C7.54048 13.9935 7.82663 13.875 8.125 13.875L23.875 13.875C24.1734 13.875 24.4595 13.9935 24.6705 14.2045C24.8815 14.4155 25 14.7016 25 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minusIcon.f1a8f5d9cdcec9d2f0e6bec41e5f7628.svg";
export { ForwardRef as ReactComponent };